// Components
import ListboxInput from 'components/inputs/listbox'
// Data
import propertyReportService from "data/reports-property"
import React, { FC, useState } from "react"
// Styles
import { ButtonWithPress_s, Button_s, Label_s } from "styles/app-styles"
import { ReportForm_s } from "styles/report-styles"

const HospitalityInputAssumptions: FC = (props) => {

  const objectTypeOptions = [
    { label: 'Area Measure', value: 'area_measure' },
    { label: 'Inflation', value: 'inflation' },
    { label: 'Line Item', value: 'line_items' },
    { label: 'Property', value: 'property' },
    { label: 'Rooms', value: 'rooms' },
    { label: 'Valuation Settings', value: 'valuation_settings'}
  ]

  const [selected_reports, setReports] = useState<any>(objectTypeOptions.map(option => option.value));

  function submit():void {
    propertyReportService.propertyReport({
      report: 'hospitality_input_assumptions',
      params: {
        selected_reports
      }
    })
  }

  return (
    <div>
      <ButtonWithPress_s primary onClick={submit} style={{marginBottom: 10}} disabled={selected_reports.length === 0}>Run Report</ButtonWithPress_s>
      <ReportForm_s>
        <div style={{width: '200px'}}>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10}}>
            <Label_s>Object Type</Label_s>
            <Button_s onClick={()=>{ selected_reports.length === objectTypeOptions.length ? setReports([]) : setReports(objectTypeOptions.map(option => option.value))}}>
              {selected_reports.length === objectTypeOptions.length ? 'Deselect All' : 'Select All'}
            </Button_s>
          </div>
          <ListboxInput field="valuationPeriod" value={selected_reports} options={objectTypeOptions} persist={(field:string, val:string)=>setReports(val)} multiple={true} />
        </div>
      </ReportForm_s>
    </div>
  )
}

export default HospitalityInputAssumptions
